'use client';
var classes = {"root":"m_f698e191","subtree":"m_75f3ecf","node":"m_f6970eb1","label":"m_dc283425"};

export { classes as default };
//# sourceMappingURL=Tree.module.css.mjs.map
